import React, { useContext } from "react";

import { storageHelper } from "lib/helpers";
import { SkeletonAnnotated } from "lib/components";
import { PrivateContext } from "lib/context";

import constant from "lib/constant/constant";
import { OperatorProductLakeEdit } from "./operator/features";
import { ProviderProductLakeEdit } from "./provider/features";

const { userKey } = constant;
const { operator, provider } = userKey;

const ProductLakeEdit = () => {
  const { isLoading } = useContext(PrivateContext);
  const getComponent = (role) => {
    if (role === operator) {
      return <OperatorProductLakeEdit />;
    }
    if (role === provider) {
      return <ProviderProductLakeEdit />;
    }
    return null;
  };
  if (isLoading) {
    return <SkeletonAnnotated />;
  }

  const currentUserRole = storageHelper.get("userRole");
  const ProductEditComponent = getComponent(currentUserRole);
  return ProductEditComponent;
};

export default ProductLakeEdit;
